import type { Dayjs } from "dayjs";
import dayjs from "../../dayjs";

export const ACCEPTED_PASTE_DATE_FORMATS = [
  "DD.MM.YYYY",
  "D.M.YYYY",
  "YYYY.MM.DD",
  "YYYY-MM-DD",
  "DD-MM-YYYY",
  "D-M-YYYY",
] as const;

export function parsePastedDate(pastedRaw: string): Dayjs | undefined {
  const pasted = pastedRaw.trim();
  if (!pasted) {
    return undefined;
  }

  for (const format of ACCEPTED_PASTE_DATE_FORMATS) {
    const parsed = dayjs.utc(pasted, format, true);
    if (parsed.isValid()) {
      return parsed;
    }
  }
  return undefined;
}
